import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17">
    <g fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="1.5">
      <path d="M.757 6L5 1.757 9.243 6M9.243 11L5 15.243.757 11" />
    </g>
  </svg>
);
